export default __webpack_public_path__ + "static/media/CN_Fond_Smartphone.fca9bd46.jpg";